export default __webpack_public_path__ + "static/evet-59b81966ad020623f523118c08687434.mp4";